export function viewerStatsEnabled(): boolean {
  return import.meta.env.DEV
}
